(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();

(function (Helper, Config, Model, Handlebars, Constantes, Analytics, Message, $) {
  'use strict';

  // ==================================================
  // Objeto con validaciones basicas
  // ==================================================    
  Helper.Validators = {
    username: /^[A-Za-z0-9_.-]{4,24}$/,
    email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"\%]+\.)+[^<>()[\]\.,;:\s@\"\%]{2,})$/i,
    password: /^[A-Za-z0-9 !@#$%^&*()_.-]{1,20}$/,
    passwordRegistro: /^[A-Za-z0-9 _]{8,20}$/,
    name: /^[A-Za-zÀ-ÿ ]{2,50}$/,
    lastname: /^[A-Za-zÀ-ÿ ]{2,50}$/,
    confirmCode: /^[A-Za-z0-9]{3,24}$/,
    credencialClub: /^[0-9]{15}?/,
    credencialClub1: /^[0-9]{6}?/,
    credencialClub2: /^[0-9X]{8}?/,
    credencialClub3: /^[0-9]{2}?/,
    dni: /^[0-9]{7,8}$/,
    passport: /^[A-Za-z0-9]{6,10}?/,
    temporary: /loginTemporalKey/
  };

  Helper.Validators.Max = {
    username: 9,
    password: 20,
    name: 50,
    lastname: 50,
    confirmCode: 24,
    credencialClub: 15,
    credencialClub1: 5,
    credencialClub2: 7,
    credencialClub3: 1,
    dni: 8,
    passport: 10
  };

  var isNewUser = false;




  // ==================================================
  // Setea el titulo de la pagina
  // Params : {string}
  // ==================================================    
  Helper.setPageTitle = function (title) {
    document.title = title;
  }

  Helper.setFirstStart = function (bool) {
    Model.Window.firstStart = bool;
  }

  Helper.checkFirstStart = function () {
    return Model.Window.firstStart;
  }

  // ==================================================
  // Redireccion
  // Params : {string}
  // ==================================================   
  Helper.redirectUrl = function (url) {
    window.location = url;
  }

  // ==================================================
  // Redireccion Passport
  // Params : {string}
  // ==================================================   
  Helper.redirectPassport = function (url) {
    logger && logger.debug('redirectPassport (url =' + url + ' )');

    console.log("Redirect passport", url);
    window.location = Config.urlPassport + encodeURIComponent(url);
  }

  // ==================================================
  // Muestra preloader
  // ==================================================
  Helper.showPreloader = function () {
    $('#main-view').addClass("loading").each(function () {
      Helper.disableNextButton();
      $('.preloader-right').css("display", "block");
    });
  }

  // ==================================================
  // Oculta preloader
  // ==================================================
  Helper.hidePreloader = function () {
    $('#main-view').removeClass("loading").each(function () {
      Helper.enableNextButton();
      $('.preloader-right').css("display", "none");
    })
  }

  Helper.removeBlur = function () {
    $('#main-view').removeClass("loading");
  }

  // ==================================================
  // Valida si esta vacio cualquier tipo de dato
  // Params : {obj} || {arr} || {str}
  // ==================================================
  Helper.isEmpty = function (obj) {
    if (obj == null) return true;
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }


  Helper.setToken = function (token) {
    if (Helper.isEmpty(token)) return;
    Helper.createCookie('token', token, Config.cookieExpirationTime, Config.dominioCookie);
    Model.Usuario.xToken = token;
    if (typeof (Storage) !== "undefined") {
      sessionStorage.setItem("token", token);
    }
    Model.Usuario.xToken = token;
  }

  Helper.updateToken = function () {
    Model.Usuario.xToken = Helper.readCookie("token");
  }

  Helper.setXValue = function (xvalue) {
    if (Helper.isEmpty(xvalue)) return;
    Helper.createCookie('xvalue', xvalue, Config.cookieExpirationTime, Config.dominioCookie);
    Model.Usuario.xValue = xvalue;
    if (typeof (Storage) !== "undefined") {
      sessionStorage.setItem("xvalue", xvalue);
    }
  }



  // ==================================================
  // Setea en cookies todo un objeto
  // ==================================================
  Helper.setupCookies = function (obj) {
    for (var key in obj) {
      var aux;
      var cookie;



      // Busco si la key se encuentra en el diccionario de cookies para ver si la grabo o no . 
      if (Config.DiccionarioCookiesAGuardar.indexOf(key) > -1 && typeof obj[key] == "string") {
        switch (key) {
          case 'UsuarioDetalleGuid':
            var valor = Helper.readCookie('token');
            if (Model.Usuario) {
              if (Helper.isEmpty(Model.Usuario.xToken)) {
                var email = Helper.isEmpty(Model.Usuario.Email) ? Helper.isEmpty(Model.Usuario.GMail) ? Model.Usuario.FbEmail : Model.Usuario.GMail : Model.Usuario.Email;
                Model.Usuario.xToken = Helper.readCookie('token');
                if (Helper.isEmpty(Model.Usuario.xToken)) {
                  if (typeof (Storage) !== "undefined") {
                    Model.Usuario.xToken = sessionStorage.token;
                    if (Helper.isEmpty(Model.Usuario.xToken)) {
                      logger && logger.error("setupCookies token null y NO lo recupero de storage =>  Email: " + email);
                    }
                    else {
                      Helper.createCookie('token', Model.Usuario.xToken, Config.cookieExpirationTime, Config.Constantes.dominioCookie);
                      logger && logger.warn("setupCookies token null y ok en storage =>  Email: " + email);
                    }
                  }
                  else {
                    logger && logger.error("setupCookies token null y no permite storage =>  Email: " + email);
                  }
                }
              }
              valor = Model.Usuario.xToken;
            }
            aux = "usuario%5Fdetalle%5Fguid";
            cookie = '{' + valor + '}';
            break;
          case 'UsuarioDetalleNick':
            aux = "usuario%5Fdetalle%5Fnick";
            cookie = obj[key];
            break;
          case 'UsuarioId':
            aux = "usuario%5Fid";
            cookie = obj[key];
            break;
          case 'UsuarioUsuario':
            aux = "usuario%5Fusuario";
            cookie = obj[key];
            break;
          case 'usuarioLogTkn':
            aux = "usuario%5Flogtkn";
            cookie = obj[key];
            break;
          case 'TokenJWT':
            aux = "PersoTKN";
            cookie = obj[key];
            break;
          default:
            if (key == 'token') {
              // no deberia setear token por aca, envio log error si se da el caso.
              var email = Helper.isEmpty(Model.Usuario.Email) ? Helper.isEmpty(Model.Usuario.GMail) ? Model.Usuario.FbEmail : Model.Usuario.GMail : Model.Usuario.Email;
              logger && logger.error('setupCookies token default => Email: ' + email);
            }

            aux = key;
            cookie = obj[key];
        }
        Helper.createCookie(aux, cookie, Config.cookieExpirationTime, Config.dominioCookie);
      }
    }
    if (typeof (Storage) !== "undefined") {
      sessionStorage.clear();
    }
  }

  Helper.areCookiesEnabled = function () {
    if (navigator.cookieEnabled)
      return true;

    var CookieName = 'CookiesEnabledCheck';

    try {
      document.cookie = `${CookieName}=1`;

      var enabled = document.cookie.indexOf(`${CookieName}=`) != -1;

      document.cookie = `${CookieName}=1; expires=Thu, 01-Jan-1970 00:00:01 GMT`;

      return enabled;
    }
    catch (e) {
      return false;
    }
  };

  // ==================================================
  // Crea una cookie
  // Params : {str} {str} {str} {str}
  // ==================================================
  Helper.createCookie = function (name, value, seconds, domain) {
    logger && logger.debug('createCookie [' + name + ']=' + value);
    var expires;
    if (seconds) {
      var date = new Date();
      date.setTime(date.getTime() + (seconds * 1000));
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }

    if (document.domain === 'localhost') {
      document.cookie = name + "=" + value + expires + "; path=/";
    } else {
      document.cookie = name + "=" + value + expires + ";domain=" + domain + "; path=/";
    }
  }

  // ==================================================
  // Lee el valor de una cookie
  // Params : {str}
  // ==================================================   
  Helper.readCookie = function (name) {
    logger && logger.debug('readCookie [' + name + ']');
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // ==================================================
  // Borra todas las cookies
  // ==================================================   
  Helper.deleteAllCookies = function () {
    logger && logger.debug('deleteAllCookies');
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      if (Config.DiccionarioCookiesAGuardar.indexOf(name.trim()) > -1) {
        if (document.domain === 'localhost') {
          //console.log("Delete Cookie - Name : " + name);
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
        } else {
          //console.log("Delete Cookie - Name : " + name);
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + Config.dominioCookie;
        }
      }
    }
  }



  Helper.deleteCookieName = function (n) {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

      if (n == name.trim()) {
        if (document.domain === 'localhost') {
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
        } else {
          //console.log("Delete Cookie - Name : " + name);
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + Config.dominioCookie;
        }
      }
    }
  }


  // ==================================================
  // Borra cookie según nombre dado 
  // ==================================================   
  Helper.deleteCookie = function (name) {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + Config.dominioCookie;
  }

  // ==================================================       
  Helper.setCanSubmit = function (bool) {
    Model.Window.canSubmit = bool;
  }

  Helper.canSubmit = function () {
    return Model.Window.canSubmit;
  }

  // ==================================================
  // Trae Todos los inputs del dom
  // ==================================================   
  Helper.getAllInputs = function () {
    var inputs = $(':input');
    var values = {};
    inputs.each(function () {
      values[this.name] = $(this).val();
    });
    return values;
  }

  // ==================================================
  // Trae Todos los inputs del dom y los convierte a un objeto
  // ==================================================   
  Helper.getAllInputsObject = function () {
    var inputs = $(':input');
    return inputs;
  }

  // ==================================================
  // Extrae un parametro de la current url
  // ==================================================   
  Helper.getURLParameter1 = function (n) {
    return decodeURIComponent((new RegExp('[?|&]' + n + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
  }

  Helper.getURLParameter = function (n) {
    var pathArray = window.location.pathname.replace("/ingresar/", "").replace("/clave/", "").split('/');
    debugger
    switch (n) {
      case 'param1':
        return (!Helper.isEmpty(pathArray[0])) ? pathArray[0] : null;
        break;
      case 'param2':
        return (!Helper.isEmpty(pathArray[1])) ? pathArray[1] : null;
        break;
      case 'param3':
        return (!Helper.isEmpty(pathArray[2])) ? pathArray[2] : null;
        break;
      case 'param4':
        return (!Helper.isEmpty(pathArray[3])) ? pathArray[3] : null;
        break;
      default:
        return null;
        break;
    }
  }

  Helper.getURLQueryString = function () {
    return window.location.search.replace("?", "");
  }

  Helper.findGetParameter = function (url, parameterName) {
    var result = null,
      tmp = [];
    url.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
        tmp = item.split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      });
    return result;
  }

  // ==================================================
  // Helpers Custom
  // ================================================== 

  // ==================================================
  // Setea el step actual en el modelo Window
  // ==================================================     
  Helper.setCurrentStep = function (step) {
    Model.Window.currentStep = step;
  }

  Helper.getCurrentStep = function () {
    return Model.Window.currentStep;
  }

  Helper.callView = function (view, data, cb, reload) {
    Helper.addStep(view, data, cb, reload);
  }

  // ==================================================
  // Valida si el modo en la URL esta permitido (Se saca desde config.js)
  // ================================================== 
  Helper.modoPermitido = function (modo) {
    if (Config.Modos.indexOf(modo) == -1) return false;
    return true;
  }

  // ==================================================
  // Valida si el sitio en la URL esta permitido (Se saca desde config.js)
  // ================================================== 
  Helper.sitioPermitido = function (sitio) {
    if (Config.Sitios[sitio] == null) return false;
    return true;
  }

  Helper.ocultarMail = function (email) {
    if (email != null && email != "" && email != "undefined") {

      var hasta = email.indexOf('@');
      var dominio = email.substring(hasta, email.length);
      var nombreMail = email.substring(0, 1) + "****";

      nombreMail += dominio;

      return nombreMail;
    }

    return "";
  }


  Helper.getTemplateAjax = function (path, data, cb) {
    var source;
    var template;
    Model.Usuario.EmailCodificado = Helper.ocultarMail(Model.Usuario.Email);
    var viewContent = {
      Config: Config,
      Model: Model,
      Data: data,
      Message: Message,
      Constantes: Constantes
    }
    $.ajax({
      url: path,
      cache: true
    }).done(function (res, status, xhr) {
      source = res;
      template = Handlebars.compile(source);
      $('#main-view').html(template(viewContent)).each(function () {
        Helper.setCanSubmit(true);
        cb && cb();
      });
    });
  }

  Helper.getBackgroundAjax = function (path, cb, data) {
    var source;
    var template;
    var viewContent = {
      Config: Config,
      Data: data,
      Message: Message,
      Constantes: Constantes
    }
    $.ajax({
      url: path,
      cache: true
    }).done(function (data, status, xhr) {
      source = data;
      template = Handlebars.compile(source);
      $('#background').html(template(viewContent)).each(function () {
        Helper.setCanSubmit(true);
        cb && cb();
      });
    });
  }

  Helper.guid = function () {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  Helper.getHeaderAjax = function (path, cb, data) {
    var source;
    var template;
    var viewContent = {
      Config: Config,
      Data: data,
      Message: Message,
      Constantes: Constantes
    }
    $.ajax({
      url: path,
      cache: true
    }).done(function (data, status, xhr) {
      source = data;
      template = Handlebars.compile(source);
      $('#header').html(template(viewContent)).each(function () {
        Helper.setCanSubmit(true);
        cb && cb();
      });
    });
  }

  // ==================================================
  // Agrega una nueva vista reemplazando la actual
  // step = Step valido sacado de config.js
  // data = Todas las vistas tienen objeto de referencia llamado Data para ser usado por handlebars al compilar, se envia en forma de objeto 
  // cb = callback post ejecucion
  // reload = true / false Esto permite forzar el reload de una pantalla si lo requisiera
  // ==================================================     
  Helper.addStep = function (step, data, cb, reload) {
    var currentStep = Helper.getCurrentStep();
    var stepFile = Config.Step[step].file;
    var flow = Config.Step[step].flow;
    var data = data || {};
    Helper.setPageTitle(Config.Step[step].title);
    if (flow.length > 0 && flow.indexOf(currentStep) == -1) throw new Error("Flow no permitido");
    Helper.setCurrentStep(stepFile);
    console.log('STEP:' + stepFile);
      if (document.getElementById(stepFile) === null || reload) {
      $('#main-view').fadeOut('fast', function () {
        Helper.getTemplateAjax(Config.urlViews + 'steps/' + stepFile, data, function () {
          $('.steps').addClass('hide').each(function (index, el) {

            Helper.cleanKeyPress();
            Helper.hidePreloader();
            Helper.explorador();
            Helper.disableTop();
            Helper.addResponsiveText();
            Helper.addReturnBackArrow();
            Helper.placeHolderAnimationOnStepLoad();
            Helper.customSetup();
            $('#main-view').fadeIn('fast');
            $('.top-content p').css('display', 'block');
            Analytics.paginaVirtual(stepFile);


            if (Model.Window.modo == 'S') Analytics.paginaVirtualSignWall(stepFile);
            /* Set Analitycs event*/
            if (Helper.checkFirstStart() === false) {
              (typeof (ga) !== "undefined") && ga('set', 'page', '/' + stepFile);
              (typeof (ga) !== "undefined") && ga('send', 'pageview');
            }

            cb && cb();


            Helper.setFirstStart(false);
          });
        })
      });
    }
  }

  // Retorna un entero aleatorio entre min (incluido) y max (excluido)    
  Helper.getRandomInt = function (min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  Helper.addReturnBackArrow = function () {
    if ($(".atras-form").length) $('#atras-header').attr('data-step', $(".atras-form").data('step'));
  }

  Helper.explorador = function () {
    // NAVEGADOR FIX
    var BrowserDetect = {
      init: function () {
        this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "an unknown version";
        this.OS = this.searchString(this.dataOS) || "an unknown OS";
      },
      searchString: function (data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;
          this.versionSearchString = data[i].versionSearch || data[i].identity;
          if (dataString) { if (dataString.indexOf(data[i].subString) != -1) return data[i].identity; } else if (dataProp) return data[i].identity;
        }
      },
      searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index == -1) return;
        return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
      },
      dataBrowser: [{ string: navigator.userAgent, subString: "Chrome", identity: "Chrome" }, { string: navigator.userAgent, subString: "OmniWeb", versionSearch: "OmniWeb/", identity: "OmniWeb" }, { string: navigator.vendor, subString: "Apple", identity: "Safari", versionSearch: "Version" }, { prop: window.opera, identity: "Opera", versionSearch: "Version" }, { string: navigator.vendor, subString: "iCab", identity: "iCab" }, { string: navigator.vendor, subString: "KDE", identity: "Konqueror" }, { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" }, { string: navigator.vendor, subString: "Camino", identity: "Camino" }, {  // for newer Netscapes (6+)
        string: navigator.userAgent,
        subString: "Netscape",
        identity: "Netscape"
      }, { string: navigator.userAgent, subString: "MSIE", identity: "Explorer", versionSearch: "MSIE" }, { string: navigator.userAgent, subString: "Gecko", identity: "Mozilla", versionSearch: "rv" }, {  // for older Netscapes (4-)
        string: navigator.userAgent,
        subString: "Mozilla",
        identity: "Netscape",
        versionSearch: "Mozilla"
      }],
      dataOS: [{ string: navigator.platform, subString: "Win", identity: "Windows" }, { string: navigator.platform, subString: "Mac", identity: "Mac" }, { string: navigator.userAgent, subString: "iPhone", identity: "iPhone/iPod" }, { string: navigator.platform, subString: "Linux", identity: "Linux" }]


    };
    BrowserDetect.init();
    var browserDetection = BrowserDetect.browser;
    var browserVersion = 'v' + BrowserDetect.version;
    var OSname = BrowserDetect.OS;
    $('body').addClass(browserDetection + ' ' + browserVersion + ' ' + OSname);
    // NAVEGADOR FIX
  }


  Helper.disableTop = function () {
    if ($('.cabezal-black').length) {
      $('main').addClass('login-black');
      $('#main-view').addClass('no-top');
      $(window).on("load", function (event) {
        if ($(this).width() < 999) {
          $(".bottom-content, #contenedor>div").addClass('mobile');
        } else {
          $(".bottom-content, #contenedor>div").removeClass('mobile');
        }
      });
    };
    $('body').scrollTop(0);
  }



  Helper.addResponsiveText = function () {
    if ($(".responsive-content").length) $('.responsive-content-body').html($('.responsive-content').html());
  }

  Helper.addBackground = function (cb) {
    var file = Config.Background[Model.Window.modo].file;
    if (Config.Background[Model.Window.modo].class) $("#background").addClass(Config.Background[Model.Window.modo].class);
    if (!file) throw new Error("No existe el background");
    Helper.getBackgroundAjax(Config.urlViews + "backgrounds/" + file, function () {
      cb && cb();
    })
  }

  Helper.addHeader = function (cb) {
    var file = Config.Header[Model.Window.modo].file;
    if (!file) throw new Error("No existe el header");
    Helper.getHeaderAjax(Config.urlViews + "headers/" + file, function () {
      cb && cb();
    })
  }

  Helper.returnBack = function (options) {
    var pagina = ((!Helper.isEmpty(options) && !Helper.isEmpty(options.url)) ? options.url : Model.Window.pagina);
    if (!Helper.isEmpty(pagina)) Helper.redirectUrl(pagina || Config.defaultRedirectUrl);
  }

  Helper.returnBackPassport = function (options) {

    var pagina = ((!Helper.isEmpty(options) && !Helper.isEmpty(options.url)) ? options.url : Model.Window.pagina);
    if (!Helper.isEmpty(pagina)) Helper.redirectPassport(pagina || Config.defaultRedirectUrl);
  }

  Helper.returnBackLogout = function (options) {
    var pagina = ((!Helper.isEmpty(options) && !Helper.isEmpty(options.url)) ? options.url : Model.Window.pagina);
    if (!Helper.isEmpty(pagina)) Helper.redirectUrl(pagina || Config.defaultRedirectUrl);
  }

  Helper.changeStatus = function (selector, status, message, analyticsMessage, cb) {
    Helper.displayMessage(selector, status);
    Helper.hidePreloader();

    if (!Helper.isEmpty(message)) Analytics.formError(selector.attr('id') + '-' + analyticsMessage);

    if (status == false && message) selector.parent().find('span').html(message);
    else selector.parent().find('span').html('');
    cb && cb();
  }

  Helper.cleanStatus = function (selector) {
    selector.removeClass("error");
    selector.removeClass("check");
    selector.parent().removeClass("error");
    selector.parent().removeClass("check");
    selector.find("span").html('');
  }

  Helper.displayMessage = function (selector, status) {
    if (status) {
      selector.parent(".input").removeClass('error');
      selector.parent(".input").addClass('check');
    } else {
      selector.parent(".input").addClass('error');
      selector.parent(".input").removeClass('check');
    }
  }

  Helper.displayCustomMessageError = function (selector, message, analyticsError) {
    Analytics.error(analyticsError);
    selector.html('').html(message);
    }

    Helper.displayCustomMessageFormError = function (selector, message, analyticsError) {
        Analytics.formError(Helper.getCurrentStep() + '-' +analyticsError);
        selector.html('').html(message);
    }

  Helper.cleanCustomMessageError = function (selector) {
    selector.html('');
  }

  Helper.placeHolderAnimation = function (obj, method) {
    obj.parent(".input").each(function () {
      $("label", this).css({
        "line-height": "20px",
        "font-size": "12px",
        "top": "0px",
      });
      $(".spin", this).css({
        "width": "100%"
      });
      if (method != "focus") $("input", this).focus();
    });
  }

  Helper.placeHolderAnimationOnStepLoad = function () {
    $('input').each(function () {
      if (!Helper.isEmpty($(this).val())) {
        Helper.changeStatus($(this), true);
        Helper.enableNextButton();
        $(this).parent().find("label").css({
          "line-height": "20px",
          "font-size": "12px",
          "top": "0px",
        });
      }
    });
  }

  Helper.checkNextButton = function (selector) {
    Helper.cleanStatusInputs();
    if (!Helper.isEmpty(selector.val())) Helper.enableNextButton();
    else Helper.disableNextButton();
  }

  Helper.enableNextButton = function () {
    $('.next-step').addClass('active');
    $('.next-step').prop("disabled", false);
  }

  Helper.disableNextButton = function () {
    $('.next-step').removeClass('active');
    $('.next-step').prop("disabled", true);
  }

  Helper.placeHolder = function () {
    //if ($('.mostrarPass').length > 0) {
    Helper.showHide();
    //}   
    $(document.body).on('click', "div.input label", function (e) {
      e.preventDefault();
      Helper.placeHolderAnimation($(this), "click");
    });

    $(document.body).on('focus', "div.input input", function (e) {
      e.preventDefault();
      Helper.placeHolderAnimation($(this), "focus");
    });


    $(document.body).on('blur', "div.input input", function (e) {
      $(".spin").css({
        "width": "0px"
      });
      if ($(this).val() == "") {
        $(this).parent(".input").each(function () {
          $("label", this).css({
            "line-height": "33px",
            "font-size": "14px",
            "font-weight": "400",
            "top": "15px",
          });
        });
      }
    })
  };

  Helper.cleanSpecialCharsInput = function (str) {
    return Helper.removeDiacritics(Helper.removeSpecialChars(str));
  }

  Helper.removeSpecialChars = function (str) {
    return str.replace(/[^a-zA-ZÀ-ÿ ]/g, "")
  }

  Helper.removeDiacritics = function (str) {
    var defaultDiacriticsRemovalMap = [
      { 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g },
      { 'base': 'AA', 'letters': /[\uA732]/g },
      { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g },
      { 'base': 'AO', 'letters': /[\uA734]/g },
      { 'base': 'AU', 'letters': /[\uA736]/g },
      { 'base': 'AV', 'letters': /[\uA738\uA73A]/g },
      { 'base': 'AY', 'letters': /[\uA73C]/g },
      { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g },
      { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g },
      { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g },
      { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g },
      { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g },
      { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g },
      { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g },
      { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g },
      { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g },
      { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g },
      { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g },
      { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g },
      { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g },
      { 'base': 'LJ', 'letters': /[\u01C7]/g },
      { 'base': 'Lj', 'letters': /[\u01C8]/g },
      { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g },
      { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g },
      { 'base': 'NJ', 'letters': /[\u01CA]/g },
      { 'base': 'Nj', 'letters': /[\u01CB]/g },
      { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g },
      { 'base': 'OI', 'letters': /[\u01A2]/g },
      { 'base': 'OO', 'letters': /[\uA74E]/g },
      { 'base': 'OU', 'letters': /[\u0222]/g },
      { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g },
      { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g },
      { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g },
      { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g },
      { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g },
      { 'base': 'TZ', 'letters': /[\uA728]/g },
      { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g },
      { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g },
      { 'base': 'VY', 'letters': /[\uA760]/g },
      { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g },
      { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g },
      { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g },
      { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g },
      { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g },
      { 'base': 'aa', 'letters': /[\uA733]/g },
      { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g },
      { 'base': 'ao', 'letters': /[\uA735]/g },
      { 'base': 'au', 'letters': /[\uA737]/g },
      { 'base': 'av', 'letters': /[\uA739\uA73B]/g },
      { 'base': 'ay', 'letters': /[\uA73D]/g },
      { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g },
      { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g },
      { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g },
      { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g },
      { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g },
      { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g },
      { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g },
      { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g },
      { 'base': 'hv', 'letters': /[\u0195]/g },
      { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g },
      { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g },
      { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g },
      { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g },
      { 'base': 'lj', 'letters': /[\u01C9]/g },
      { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g },
      { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g },
      { 'base': 'nj', 'letters': /[\u01CC]/g },
      { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g },
      { 'base': 'oi', 'letters': /[\u01A3]/g },
      { 'base': 'ou', 'letters': /[\u0223]/g },
      { 'base': 'oo', 'letters': /[\uA74F]/g },
      { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g },
      { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g },
      { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g },
      { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g },
      { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g },
      { 'base': 'tz', 'letters': /[\uA729]/g },
      { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g },
      { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g },
      { 'base': 'vy', 'letters': /[\uA761]/g },
      { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g },
      { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g },
      { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g },
      { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }
    ];

    for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
      str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
    }
    return str;
  }

  Helper.initialpreloader = function () {
    $('.preloader-main').delay(400).fadeOut(500);
  }

  Helper.cleanInputs = function () {
    $('.input input').val('');
  }

  Helper.cleanStatusInputs = function () {
    $(".input").each(function () {
      if (($(this).hasClass("error") || $(this).hasClass("check")) && $(this).hasClass("no-validate-keyup") == false && $(this).find("input").val() !== 0) {
        Helper.cleanStatus($(this));
      }
    });
  }

  Helper.globalResize = function () {
    Model.Window.width = $(window).width();
    Model.Window.height = $(window).height();
  }

  // on resize
  Helper.onResize = function () {
    Model.Window.width = $(window).width();
    Model.Window.height = $(window).height();
  }

  Helper.cleanKeyPress = function () {
    Model.Window.keyPress = 0;
  }

  Helper.checkCapsLock = function (e) {
    var isCapsLock = window.event.getModifierState && window.event.getModifierState('CapsLock');
    if (isCapsLock) {
      $('.aviso-mayuscula').show();
    } else {
      $('.aviso-mayuscula').hide();
    }
  }
  // ==================================================
  // Limpia el modelo, cookies y resetea parametros de URL
  // ==================================================   
  Helper.resetAll = function (cb) {
    var token = Helper.readCookie("token");
    var usuario_detalle_guid = Helper.readCookie("usuario%5Fdetalle%5Fguid");
    var cookieLogin = Helper.readCookie("cookieLogin");

    $(':input').val('');
    for (var index in Model.Usuario) {
      Model.Usuario[index] = '';
    }
    Helper.deleteAllCookies();
    if (!(Helper.isEmpty(usuario_detalle_guid) || Helper.isEmpty(cookieLogin) || Helper.isEmpty(token))) {
      Model.Usuario.HayCookie = 1;
    }
    Model.Usuario.SitioId = Model.Window.SitioId;
    cb && cb();
  }

  // ==================================================
  // Setea el model cuando tenia session anterior
  // ==================================================   
  Helper.setupPrevious = function () {
    var token = Helper.readCookie("token");
    var usuario_detalle_guid = Helper.readCookie("usuario%5Fdetalle%5Fguid");
    var cookieLogin = Helper.readCookie("cookieLogin");

    if (!(Helper.isEmpty(usuario_detalle_guid) || Helper.isEmpty(cookieLogin) || Helper.isEmpty(token))) {
      Model.Usuario.HayCookie = 1;
    }
  }

  Helper.showHide = function () {
    $(document.body).on('click', '.mostrarPass', function (e) {
      var mostrar = $(this);
      mostrar.text(function (i, text) {
        return text === "OCULTAR" ? "MOSTRAR" : "OCULTAR";
      });
      if (mostrar.text() == "OCULTAR") {
        mostrar.parent().find("input").attr("type", "text");
      } else {
        mostrar.parent().find("input").attr("type", "password");
      }
    });
  }

  Helper.resizeHandler = function () {
    Model.Window.width = $(window).width();
    Model.Window.height = $(window).height();
    //Helper.onResize();
    //Helper.globalResize();
    $(window).resize(function () {
      Helper.globalResize();
      $('#main-view').css('display', 'table');
    });

    /*$(window).resize(function() {
        Helper.onResize();
    });*/
  }

  // ==================================================
  // Obtiene la IP local/publica a traves de webrtc
  // ==================================================       

  Helper.getClientIP = function () {
    window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
    var client = new RTCPeerConnection({ iceServers: [] }),
      noop = function () { };
    client.createDataChannel(""); //create a bogus data channel
    client.createOffer(client.setLocalDescription.bind(client), noop); // create offer and set local description
    client.onicecandidate = function (ice) { //listen for candidate events
      if (!ice || !ice.candidate || !ice.candidate.candidate) return;
      var ip = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate)[1];
      Model.Window.ip = ip;
      client.onicecandidate = noop;
    };
  }

  Helper.customSetup = function () {
    var modo = Model.Window.modo;


    if (Model.Window.modo == 'D') $('.top-content').addClass('default');
    if (Model.Window.modo == 'S') {
      $('.top-content p').addClass('mobile');
      var topContent = $('.top-content');
      var newText = document.createElement('label');
      newText.className = "mobile";
      newText.innerHTML = "Para seguir leyendo ingresá con tu red social o tu e-mail";
      topContent.append(newText);
    }

    switch (modo) {

      case 'P':
        $('.top-content p').css('display', 'none');
        break;

      default:
      //
    }
  }

  /*********************************************/
  /*     Recaptcha
  /*********************************************/

  Helper.Recaptcha = {
    currentInstance: null,
    render: function (control, submit, expired) {
      this.currentInstance = grecaptcha.render(control, {
        sitekey: Config.rcId,
        'expired-callback': function () {
          console.log('recaptcha expired! reseting...');
          expired && expired();
          Helper.displayCustomMessageFormError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_EXPIRADO'], Message.Analytics.Usuario['CAPTCHA_EXPIRADO']);
          grecaptcha.ready(function () {
            grecaptcha.reset();
          });
        },
        callback: function () {
          console.log('recaptcha submit successfuly');
          submit && submit();
          Helper.cleanCustomMessageError($('#recaptcha-mensaje'));
        }
      });
    },
    getResponse: function (widget) {
      widget = widget || this.currentInstance;
      if (widget == null || widget == undefined) return;
      return grecaptcha.getResponse(widget);
    },
    excecute: function (widget) {
      widget = widget || this.currentInstance;
      if (widget == null || widget == undefined) return;
      grecaptcha.execute(widget);
    },
    reset: function (widget) {
      widget = widget || this.currentInstance;
      if (widget == null || widget == undefined) return;
      grecaptcha.reset(widget);
    },
    isSubmitted: function (widget) {
      widget = widget || this.currentInstance;
      if (widget == null || widget == undefined) return false;
      var res = grecaptcha.getResponse(widget);
      return res !== "";
    }
  };

  /*Extension helpers Handlebars*/

  Handlebars.registerHelper('compare', function (lvalue, rvalue, options) {
    if (arguments.length < 3)
      throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
    var operator = options.hash.operator || "==";
    var operators = {
      '==': function (l, r) { return l == r; },
      '===': function (l, r) { return l === r; },
      '!=': function (l, r) { return l != r; },
      '<': function (l, r) { return l < r; },
      '>': function (l, r) { return l > r; },
      '<=': function (l, r) { return l <= r; },
      '>=': function (l, r) { return l >= r; },
      'typeof': function (l, r) { return typeof l == r; },
      'esMultiplode': function (l, r) { return ((l % r) == 0); },
      'noEsMultiplode': function (l, r) { return ((l % r) != 0); }
    }
    if (!operators[operator])
      throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
    var result = operators[operator](lvalue, rvalue);
    if (result) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });


  Handlebars.registerHelper('ContextEmbedHide', function (options) {
    if (Model.Embed.Mobile || Model.Embed.Article) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  Handlebars.registerHelper('ContextEmbedShow', function (options) {
    if (Model.Embed.Mobile || Model.Embed.Article) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('ArticleContextHide', function (options) {
    if (Model.Embed.Article) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  Handlebars.registerHelper('ArticleContextShow', function (options) {
    if (Model.Embed.Article) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Helper.getHeader = function (res, position) {
    try {
      return (res.split("|")[position]);
    }
    catch (ex) {
      return null;
    }

  }

    Helper.StartExperiment = function (experimentId) {
        let experiment = null;

        for (let i in Constantes.Experiments) {
            let item = Constantes.Experiments[i];

            if (item.id !== experimentId || !item.active)
                continue;

            experiment = item;

            break;
        }

        if (experiment) {
            const experimentCookieName = `exp_${experiment.id}`;
            let experimentCookieValue = Helper.readCookie(experimentCookieName);

            if (!experimentCookieValue) {
                Helper.createCookie(experimentCookieName, experiment.variations[Helper.getRandomInt(0, Object.keys(experiment.variations).length)], Config.cookieExpirationTime, Config.dominioCookie);
                experimentCookieValue = Helper.readCookie(experimentCookieName);
            }

            var hasExperiment = Model.Usuario.Experiments
                .filter(x => (x.id === experiment.id)).length > 0;

            if (!hasExperiment) {
                Model.Usuario.Experiments.push({
                    id: experiment.id,
                    variation: experimentCookieValue
                });
            }

            try {
                if (typeof ga !== 'undefined') {
                    ga('set', 'exp', `${experiment.id}.${experimentCookieValue}`);
                    ga('send', 'pageview');
                }
            }
            catch (e) {
                console.log('ERROR', e);
            }
        }
    }

})(LN.Helper, LN.Config, LN.Model, Handlebars, window.config.Constantes, LN.Analytics, LN.Message, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/login/core/helper.js